import { inject } from '@angular/core';
import { StatusPageGuardService } from './status-page-guard.service';

export const statusPageGuard = () => {
    const statusPageGuardService = inject(StatusPageGuardService);

    return statusPageGuardService.canActivate();
};
